import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import Endpoints from '@/enums/Endpoints';

type UltimoServicioTerminalRequest = {
  oidVisita: number;
};

type ServicioTerminalValue = {
  camion: string | null;
  camionero: string | null;
  certificadoIMO: boolean;
  certificadoIMOSpecified: boolean;
  desde: string;
  desdeSpecified: boolean;
  entregaDirecta: boolean;
  entregaDirectaSpecified: boolean;
  estado: string;
  estadoTraslado: number;
  estadoTrasladoSpecified: boolean;
  factura: string | null;
  fechaCumplido: string;
  fechaCumplidoSpecified: boolean;
  fechaEnCamion: string;
  fechaEnCamionSpecified: boolean;
  hasta: string;
  hastaSpecified: boolean;
  importe: number | null;
  importeSpecified: boolean;
  oidDocumento: number;
  oidDocumentoSpecified: boolean;
  oidIntercambio: number;
  oidIntercambioSpecified: boolean;
  oidReserva: number;
  oidReservaSpecified: boolean;
  oidSecuenciaDeEntrega: number | null;
  oidSecuenciaDeEntregaSpecified: boolean;
  oidServicioTerminal: number;
  oidServicioTerminalSpecified: boolean;
  oidVisita: number;
  oidVisitaSpecified: boolean;
  preparado: boolean;
  preparadoSpecified: boolean;
  secuencia: number;
  secuenciaSpecified: boolean;
  servicioAdicional: string | null;
  tareaTraslado: string | null;
  tipoServicio: string;
  usuarioIniciado: string | null;
  vacio: boolean;
  vacioSpecified: boolean;
  viajaSolo: boolean;
  viajaSoloSpecified: boolean;
};

type UltimoServicioTerminalResponse = {
  error: string | null;
  exception: string | null;
  isFaulted: boolean;
  isSuccess: boolean;
  state: number;
  value: ServicioTerminalValue;
};

export const ultimoServicioTerminal = async (
  query: UltimoServicioTerminalRequest
): Promise<ServicioTerminalValue> => {
  try {
    const res = await apiClient.post<UltimoServicioTerminalResponse>(
      Endpoints.UltimoServicioTerminal,
      query
    );

    if (!res?.data?.isSuccess) {
      throw new Error(
        res?.data?.error ||
          res?.data?.exception ||
          'Error getting terminal service'
      );
    }

    if (res?.data?.isFaulted) {
      throw new Error(res?.data?.exception || 'Service faulted');
    }

    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
